import {
  withCompInfo,
  createComponentMapperModel,
} from '@wix/editor-elements-integrations';
import type {
  SvgImageProps,
  SvgImageDefinition,
  SvgImageCarmiProps,
  SvgImageStyleType,
} from '../SvgImage.types';
import { svgImagePropsTransformer } from './SvgImagePropsTransformer';

export const props = withCompInfo<
  SvgImageProps,
  SvgImageDefinition,
  SvgImageCarmiProps
>()(
  ['compData', 'styleProperties', 'siteColors'],
  ({ compData, styleProperties, siteColors }, carmiData) => {
    const { svgId, id, alt, displayMode } = compData;
    const { svgString, svgInfo, link } = carmiData;
    const styleTypedProperties =
      styleProperties as unknown as SvgImageStyleType;

    const transformedSvgString = svgImagePropsTransformer(svgString, {
      svgId,
      svgInfo,
      altText: alt,
      displayMode,
      colorsMap: siteColors,
      shapeStyle: styleTypedProperties,
    });

    return {
      id,
      link,
      alt,
      svgString: transformedSvgString,
    };
  },
);

export default createComponentMapperModel({
  props,
});
